import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { IngredientCardClickEvent } from '@app/mpp/model/ingredient-card-click-event';
import { IngredientCard } from '@app/mpp/model/ingredient-card-model';
import { getUOMTranslation, UOM } from '@app/mpp/shared/enum/mpp-enums';
import { PlatformEnum } from '@panamax/app-state';
import { ItemType } from '@usf/mpp-types';

@Component({
  selector: 'app-ingredients-card',
  templateUrl: './ingredients-card.component.html',
  styleUrls: [
    './ingredients-card.component.scss',
    '../../../../styles/shared-mpp-styles.scss',
  ],
})
export class IngredientsCardComponent {
  @Input() cardData: IngredientCard;
  @Input() platform: PlatformEnum;
  @Input() containerSize = 12;
  @Input() lockEdits: boolean;
  @Output() nameClickEvent = new EventEmitter<IngredientCardClickEvent>();
  @Output() uomDropdownClickEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() quantityInputBlurEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() noteInputBlurEvent = new EventEmitter<IngredientCardClickEvent>();
  @Output() ellipsisEvent = new EventEmitter<IngredientCardClickEvent>();
  @Output() costInfoIconEvent = new EventEmitter<Event>();
  @Output() dismissCostInfoPopover = new EventEmitter();
  noteContainsEmojis = false;

  platformRef = PlatformEnum;
  typeRef = ItemType;
  constructor() {}

  ionViewWillEnter(): void {
    this.noteContainsEmojis = false;
  }

  onUomDropdownClick($event: Event) {
    $event.stopPropagation();
    this.uomDropdownClickEvent.emit({
      ingredientCard: this.cardData,
      event: $event,
    });
  }

  stopClickThrough($event: Event) {
    $event.stopPropagation();
  }

  onQuantityInputBlur($event: Event) {
    this.quantityInputBlurEvent.emit({
      ingredientCard: this.cardData,
      event: $event,
    });
  }

  onNameClick($event: Event) {
    if (this.cardData.type !== ItemType.RECIPE) {
      $event.stopPropagation();
      this.nameClickEvent.emit({
        ingredientCard: this.cardData,
        event: $event,
      });
    }
  }

  onNoteChange(value: string) {
    this.noteContainsEmojis = /\p{Extended_Pictographic}/u.test(value);
  }

  onNoteInputBlur($event: Event) {
    if (!this.noteContainsEmojis) {
      this.noteInputBlurEvent.emit({
        ingredientCard: this.cardData,
        event: $event,
      });
    }
  }

  onEllipsisClick($event: Event) {
    $event.stopPropagation();
    if (!this.lockEdits) {
      this.ellipsisEvent.emit({
        ingredientCard: this.cardData,
        event: $event,
      });
    }
  }

  getTranslatedUOM(uom: string): string {
    return getUOMTranslation(uom as UOM);
  }

  shouldShowZeroCostIcon(): boolean {
    return (
      !!this.cardData.quantityUom &&
      this.cardData.quantity != null &&
      this.cardData.cost === 0
    );
  }

  dismiss() {
    this.dismissCostInfoPopover.emit();
  }

  async presentZeroCostPopover($event: Event) {
    $event.stopPropagation();
    this.costInfoIconEvent.emit($event);
  }
}
